module.exports = __webpack_public_path__ + "img/insdi.3e3d7f4e.png";